module.exports = function() {
  return new Worker(__webpack_public_path__ + "6e8798af8bc7e5d2c5c6.worker.js");
};